// ./src/components/layouts/PageChrome.tsx
//
// ROADMAP A2b #58 — what a page renders where it used to render `DashboardLayout`.
//
// ⚠⚠ IT RENDERS NO DOM OF ITS OWN. The page is ALREADY inside the shell's content area — the shell
// is the route's layout and the page is its `children` — so this only has to publish the header
// chrome sideways (`usePublishPageChrome`) and pass its children straight through.
//
// ⚠ IT TAKES EXACTLY THE PROP NAMES `DashboardLayout` TOOK, on purpose. Every page already spoke
// that vocabulary; inventing a second one here would have made #58 a rewrite of 88 pages instead of
// a rename, and left two half-remembered sets of header prop names in the codebase.
//
// ⚠⚠ DO NOT SPREAD THE ROUTER'S `PageProps` INTO THIS. Pages used to write
// `<DashboardLayout {...props} …>` because the layout needed `page` for the title; the shell now
// gets `page` from the router itself. A leftover `{...props}` is not a type error — JSX does not
// excess-check spreads — so it would sit there implying this reads the route. `check-app-shell`
// fails on one.
import React from "react";

import { usePublishPageChrome, PageChromeValue } from "@/contexts/PageChromeContext";

export interface PageChromeProps extends PageChromeValue {
  children?: React.ReactNode;
}

export const PageChrome: React.FC<PageChromeProps> = ({
  children,
  headerTitle,
  headerSubtitle,
  headerSearch,
  headerFilter,
  mobileHeaderActions,
  stickyFooter,
  footerMessage,
  footerMessageType,
  showFooterMessage,
  focusMode,
}) => {
  // ⚠ Rebuilt every render on purpose — the handlers inside close over this render's state. See
  // `PageChromeContext` for why a memoised object here would be a stale-closure bug.
  usePublishPageChrome({
    headerTitle,
    headerSubtitle,
    headerSearch,
    headerFilter,
    mobileHeaderActions,
    stickyFooter,
    footerMessage,
    footerMessageType,
    showFooterMessage,
    focusMode,
  });

  return <>{children}</>;
};
